module.exports = __webpack_public_path__ + "img/canvasMenuSticking.53bb1b0f.svg";